import { axiosBase, errorHandler } from "./axios";
import { getAccessToken } from "./helper";

const BASE = "/api/v1/album-builder";

const fetchTemplate = ({ templateId }: { templateId: string }) =>
  axiosBase
    .get(`${BASE}/templates/${templateId}`, )
    .then((r) => r.data)
    .catch(errorHandler);

const createTemplate = (payload: {
  name: string;
  dimension?: string;
  numberOfSheets?: number;
  photosRequiredCount?: number;
}) =>
  axiosBase
    .post(`${BASE}/templates`, payload)
    .then((r) => r.data)
    .catch(errorHandler);

const updateTemplate = (payload: any) => {
    return axiosBase
        .put(`${BASE}/template/${payload.id}`, payload.data)
        .then((r) => r.data)
        .catch(errorHandler);
};


const listTemplates = (params?: { studioId?: string }) =>
  axiosBase
    .get(`${BASE}/templates`, { params, })
    .then((r) => r.data)
    .catch(errorHandler);

const fetchPage = ({ pageIds }: { pageIds: string[]; templateId: string }) =>
  axiosBase
    .post(`${BASE}/pages/batch`, { pageIds } )
    .then((r) => r.data)
    .catch(errorHandler);

const fetchPagesApi = ({ albumId, pageIds }: { albumId: string; pageIds: string[]; }) =>
    axiosBase
        .post(`/api/v1/event-albums/${albumId}/pages/batch`, { pageIds })
        .then((r) => r.data)
        .catch(errorHandler);

const createPage = ({ templateId, pageNumber }: { templateId: string; pageNumber: number }) =>
  axiosBase
    .post(`${BASE}/templates/${templateId}/pages`, { pageNumber }, )
    .then((r) => r.data)
    .catch(errorHandler);

const deletePage = ({ templateId, pageId }: { templateId: string; pageId: string }) =>
  axiosBase
    .delete(`${BASE}/templates/${templateId}/pages/${pageId}`, )
    .then((r) => r.data)
    .catch(errorHandler);

const reorderPages = ({ templateId, pageOrder }: { templateId: string; pageOrder: string[] }) =>
  axiosBase
    .patch(`${BASE}/templates/${templateId}/page-order`, { pageOrder }, )
    .then((r) => r.data)
    .catch(errorHandler);

const savePage = ({
  pageId,
  nodes,
  backgroundColor,
  backgroundAssetId,
  backgroundOpacity,
  label,
}: {
  pageId:              string;
  nodes:               Record<string, any>;
  backgroundColor?:    string;
  backgroundAssetId?:  string | null;
  backgroundOpacity?:  number;
  label?:              string;
}) =>
  axiosBase
    .patch(
      `${BASE}/pages/${pageId}`,
      { nodes, backgroundColor, backgroundAssetId, backgroundOpacity, label },
      
    )
    .then((r) => r.data)
    .catch(errorHandler);

const savePages = (
  pages: Array<{
    pageId:              string;
    nodes:               Record<string, any>;
    backgroundColor?:    string;
    backgroundAssetId?:  string | null;
    backgroundOpacity?:  number;
    label?:              string;
  }>,
) =>
  axiosBase
    .patch(`${BASE}/pages/batch`, { pages })
    .then((r) => r.data)
    .catch(errorHandler);

const createBackgroundSas = ({pageId,fileName}:{pageId:string,fileName:string})=>{
  return axiosBase.post( `${BASE}/page/${pageId}/sas`,{fileName})
    .then((r) => r.data)
    .catch(errorHandler);
}

const getBackgroundReadSas = (pageId: string) =>
  axiosBase.get(`${BASE}/page/${pageId}/background-sas`)
    .then((r) => r.data)
    .catch(errorHandler);

const albumBuilderService = {
  fetchTemplate,
  createTemplate,
  updateTemplate,
  listTemplates,
  fetchPage,
  createPage,
  deletePage,
  reorderPages,
  savePage,
  savePages,
  createBackgroundSas,
  getBackgroundReadSas,
  fetchPagesApi
};

export default albumBuilderService;
